import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo } from 'react';
import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import { UNFILED_ASSETS_ID } from '../constants/folders';
export default function useCurrentFolderId() {
  "use memo";

  const {
    folderId
  } = useCrmObjectType();
  let t0;
  bb0: {
    if (!folderId) {
      t0 = UNFILED_ASSETS_ID;
      break bb0;
    }
    const intFolderId = Number(folderId);
    t0 = intFolderId > 0 ? intFolderId : UNFILED_ASSETS_ID;
  }
  const resolvedFolderId = t0;
  return resolvedFolderId;
}
export function useSetCurrentFolderId() {
  "use memo";

  const $ = _c(2);
  const {
    onSetFolderId
  } = useCrmObjectType();
  let t0;
  if ($[0] !== onSetFolderId) {
    t0 = folderId => {
      onSetFolderId(folderId);
    };
    $[0] = onSetFolderId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}